import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import ImageComponent from "../../common/ImageComponent";
import { useEffect, useState } from "react";
import { MdOutlineExplore } from "react-icons/md";

export default function CourseBanner({ banner_images, showOverlay = true }) {
  const [deviceType, setDeviceType] = useState('desktop');
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      if (width < 576) {
        setDeviceType('mobile');
      } else if (width < 992) {
        setDeviceType('tablet');
      } else if (width === 1024) {
        setDeviceType('ipad');
      } else {
        setDeviceType('desktop');
      }
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const getImageHeight = () => {
    switch (deviceType) {
      case 'mobile':
        return '170px';
      case 'tablet':
        return '220px';
      case 'ipad':
        return '240px';
      default:
        return '270px';
    }
  };

  const bannerHeight = getImageHeight();

  const handleExploreClick = () => {
    const target = document.querySelector('.cr-stats-ribbon') || document.querySelector('.cr-section');
    if (target) {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  if (!banner_images || banner_images.length === 0) return null;

  return (
    <div className="cr-hero-banner position-relative">
      <Carousel
        className="no-cursor"
        showArrows={false}
        showStatus={false}
        showThumbs={false}
        showIndicators={false}
        infiniteLoop={true}
        autoPlay={true}
        interval={4500}
        selectedItem={currentSlide}
        onChange={(index) => setCurrentSlide(index)}
      >
        {banner_images.map((image, index) => (
          <ImageComponent
            key={index}
            src={image}
            compClassName="object-cover"
            img_width="100%"
            img_height={bannerHeight}
            loader_width="100%"
            loader_height={bannerHeight}
          />
        ))}
      </Carousel>

      {/* Hero Content Overlay (Hidden by default as requested) */}
      {showOverlay && (
        <div className="cr-hero-overlay">
          <span className="cr-hero-badge">Accredited Clinical Masterclasses</span>
          <h2 className="cr-hero-title">100% Doctor Approved courses</h2>
          <p className="cr-hero-subtitle">
            Elevate your skills: Enroll in our diverse online courses
          </p>
          <button className="cr-hero-cta" onClick={handleExploreClick}>
            <span>Explore more courses</span>
            <MdOutlineExplore size={17} />
          </button>
        </div>
      )}

      {/* Minimal Animated Dot Indicators */}
      {banner_images.length > 1 && (
        <div className="cr-banner-dots">
          {banner_images.map((_, i) => (
            <div
              key={i}
              onClick={() => setCurrentSlide(i)}
              className={`cr-banner-dot${currentSlide === i ? ' active' : ''}`}
              style={{ width: currentSlide === i ? '24px' : '6px' }}
            />
          ))}
        </div>
      )}
    </div>
  );
}
